import * as React from 'react';
import { createContext, useContext } from 'react';

/**
 * Report ID being QA previewed, or null outside a QA preview. Project-scoped
 * lookups (product names, map data) only know about reports already added
 * to the project, so they use this to also include the unapproved report.
 */
const QaPreviewReportContext = createContext<string | null>(null);

export const useQaPreviewReportId = (): string | null =>
  useContext(QaPreviewReportContext);

interface ProviderProps {
  /** Preview report ID, or the active QA preview session. */
  reportId?: string | null;
  session?: { reportId: string } | null;
  children: React.ReactNode;
}

export const QaPreviewReportProvider: React.FC<ProviderProps> = ({
  reportId,
  session,
  children,
}) => (
  <QaPreviewReportContext.Provider
    value={reportId ?? session?.reportId ?? null}
  >
    {children}
  </QaPreviewReportContext.Provider>
);
